module.exports = __webpack_public_path__ + "assets/img/blockImg_400x400.gif";